/* 
 * Export component file to be used on project
*/

import PaymentDetails from './PaymentDetails.js';
export default PaymentDetails;
